import {Component, Input, ElementRef, Renderer2} from "@angular/core";

@Component({
    selector: 'loading-linear',
    template: require('./loading.linear.template.html')
})
export class LinearLoadingComponent {

    @Input('loading') loading: boolean = false;

    constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    }

    ngOnInit() {
        this.renderer.setStyle(this.elementRef.nativeElement.parentElement, 'position', 'relative');
    }

    getLoadingClass() {
        if (this.loading) {
            return 'show';
        } else {
            return 'hide';
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/loading/linear/loading.linear.component.ts